export default {
  header: 'Current step',
  done: 'Done',
  inProgress: 'In progress',
  notStarted: 'Not started',
};
